export const grnHeaders = [
  { id: 1, column: 'shortage_count', name: 'shortage', tlabel: 'INDENT_SHORTAGES', charge: 'shortage_charge', unit: 'shortage_unit', class: 'w100', label: 'SHORTAGES', canExceed: false, width: 105 },
  { id: 2, column: 'damage_count', name: 'damage', tlabel: 'INDENT_DAMAGES', charge: 'damage_charge', unit: 'damage_unit', class: 'w100', label: 'DAMAGES', canExceed: false, width: 75 },
  { id: 3, column: 'carton_damage_count', name: 'carton_damage', tlabel: 'INDENT_CARTON_DAMAGES', charge: 'carton_damage_charge', unit: 'carton_damage_unit', class: 'w100', label: 'CARTON DAMAGES', canExceed: false, width: 75 },
  // { id: 4, column: 'leakage_count', class: 'w100', label: 'LEAKAGES', canExceed: false, width: 75 },
  // { id: 5, column: 'excess_count', class: 'w100', label: 'EXCESS', canExceed: true, width: 75 },
];

export const units = {
  KG: 'kg',
  MT: 'MT',
  PIECES: 'pieces',
  CASES: 'cases',
  QUANTITY_UNIT: 'QUANTITY UNIT',
  PCE_TO_QUANTITY_UNIT: 'PCE TO QUANTITY UNIT',
};

export const quantityUnits = {
  'c/s': 'cases',
  's/o': 'cases',
  cs: 'cases',
  box: 'cases',
  boxes: 'cases',
  pkg: 'cases',
  pkgs: 'cases',
  cases: 'cases',
  case: 'cases',
  nos: 'cases',
  pce: 'pieces',
  no: 'pieces',
  pcs: 'pieces',
  bags: 'cases',
  each: 'pieces',
  kg: 'kg',
  ea: 'pieces',
  pieces: 'pieces',
  kar: 'cases',
  ctn: 'cases',
  st: 'cases',
  it: 'pieces',
  pc: 'pieces',
  PC: 'pieces',
  CV: 'cases',
  cv: 'cases',
  PAC: 'pieces',
  pac: 'pieces',
};

export default grnHeaders;
